
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.571 8.875C16.464 8.875 18 7.363 18 5.5s-1.536-3.375-3.429-3.375c-1.892 0-3.428 1.512-3.428 3.375 0 .14.007.281.025.418l-3.36 1.653a3.43 3.43 0 00-2.38-.946C3.537 6.625 2 8.137 2 10s1.536 3.375 3.429 3.375a3.43 3.43 0 002.378-.946l3.36 1.653a3.207 3.207 0 00-.024.418c0 1.863 1.536 3.375 3.428 3.375 1.893 0 3.429-1.512 3.429-3.375s-1.536-3.375-3.429-3.375a3.43 3.43 0 00-2.378.946l-3.36-1.653c.017-.137.024-.274.024-.418 0-.144-.007-.281-.025-.418l3.36-1.653a3.43 3.43 0 002.38.946z","fill":"#0A0A0A"}})])
          )
        }
      }
    